/** @file The one command a draw-order move becomes: slot.setDrawOrder in setup, a draw-order key when keying. */
import type { CommandCall, Id } from '@pose2d/format/types';
import type { EditTarget } from '../rigKit/rigView';
import { orderMove, type OrderMove } from './orderMove';

/** Setup: `slot.setDrawOrder { target, above | below }`; keying: `animation.setDrawOrderKey` with the full moved `order`. */
export function reorderCall(target: EditTarget, order: readonly Id[], move: OrderMove): CommandCall {
  if (target.kind === 'key') return { name: 'animation.setDrawOrderKey', input: { animation: target.animation, frame: target.frame, order: orderMove.apply(order, move) } };
  return { name: 'slot.setDrawOrder', input: move.place === 'above' ? { target: move.slot, above: move.ref } : { target: move.slot, below: move.ref } };
}
